import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export default function UserActivityGrid({ activityData }) {
    const getLoginFrequency = (activities) => {
        const userCounts = {};
        activities.forEach((activity) => {
            const username = activity.username;
            userCounts[username] = (userCounts[username] || 0) + 1;
        });
        return userCounts;
    };

    const loginFrequency = getLoginFrequency(activityData.recentLogins);
    const mostActiveUser = Object.keys(loginFrequency).reduce(
        (a, b) => (loginFrequency[a] > loginFrequency[b] ? a : b),
        'N/A'
    );

    return (
        <Grid container spacing={3}>
            {/* Total Users */}
            <Grid item size={3}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography color="text.secondary" gutterBottom>
                            Total Users
                        </Typography>
                        <Typography variant="h4" component="div">
                            {activityData.totalUsers}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Unique users in system
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Active Today */}
            <Grid item size={3}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography color="text.secondary" gutterBottom>
                            Active Today
                        </Typography>
                        <Typography
                            variant="h4"
                            component="div"
                            color="success.main"
                        >
                            {activityData.activeUsers}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Logged in today
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Recent Logins */}
            <Grid item size={3}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography color="text.secondary" gutterBottom>
                            Recent Logins
                        </Typography>
                        <Typography
                            variant="h4"
                            component="div"
                            color="primary.main"
                        >
                            {activityData.recentLogins.length}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Last 10 activities
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Most Active User */}
            <Grid item size={3}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography color="text.secondary" gutterBottom>
                            Most Active
                        </Typography>
                        <Typography
                            variant="h6"
                            component="div"
                            color="info.main"
                        >
                            {mostActiveUser}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {loginFrequency[mostActiveUser] || 0} logins
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}
